import {DropDownListModel} from "../../drop-down/models/list-model/drop-down-list.model";
import {StationDropDownItemModel} from "./station-drop-down-item.model";

export class StationDropDownListModel extends DropDownListModel<StationDropDownItemModel> {
}
